const getProductLabelById = (state) => (id) => state.productLabelsCache.find(
  (productLabel) => productLabel.id === id,
);
const getProductLabelsByIds = (state) => (ids) => {
  state.productLabelsCache
    .filter((productLabel) => ids.includes(productLabel.id));
};

const hasProductLabelById = (state) => (id) => typeof state.productLabelsCache
  .find((productLabel) => productLabel.id === id) !== "undefined";

export default {
  getProductLabelById,
  hasProductLabelById,
  getProductLabelsByIds,
};
